import { useState, useEffect } from "react";

// Singleton: one passive listener shared across every useScrollY() consumer.
// Previously each call site registered its own handler; now only one fires on scroll.
const subscribers = new Set();
let currentY = 0;

if (typeof window !== "undefined") {
  window.addEventListener(
    "scroll",
    () => {
      currentY = window.scrollY;
      subscribers.forEach((fn) => fn(currentY));
    },
    { passive: true }
  );
}

export const useScrollY = () => {
  const [y, setY] = useState(currentY);

  useEffect(() => {
    subscribers.add(setY);
    return () => subscribers.delete(setY);
  }, []);

  return y;
};
